export const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const DEITY_ARTWORKS = [
  {
    name: "Surya",
    sanskrit: "सूर्य",
    url: "https://images.unsplash.com/photo-1621788894112-ddb767d097e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxzdXJ5YSUyMHN1biUyMGdvZCUyMHBhaW50aW50aW5nfGVufDB8fHx8MTc4MTM2Njc1MXww&ixlib=rb-4.1.0&q=85",
    caption: "Aditya — radiance of the inner sun",
  },
  {
    name: "Ganesha",
    sanskrit: "गणेश",
    url: "https://images.unsplash.com/photo-1726225130014-b73eb8e19ba7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxnYW5lc2hhJTIwc2N1bHB0dXJlJTIwbXVzZXVtfGVufDB8fHx8MTc4MTM2Njc0MHww&ixlib=rb-4.1.0&q=85",
    caption: "Ganapati — lord of beginnings",
  },
  {
    name: "Shiva",
    sanskrit: "शिव",
    url: "https://images.pexels.com/photos/37399739/pexels-photo-37399739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Mahadeva — the still witness",
  },
  {
    name: "Vishnu",
    sanskrit: "विष्णु",
    url: "https://images.unsplash.com/photo-1719495851984-dbc1e26a39e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx2aXNobnUlMjBhcnR8ZW58MHx8fHwxNzgxMzY2NzQwfDA&ixlib=rb-4.1.0&q=85",
    caption: "Vishnu — the gentle preserver",
  },
];

export const TEXTURE_MANUSCRIPT =
  "https://images.pexels.com/photos/6769734/pexels-photo-6769734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const TEXTURE_TEMPLE =
  "https://images.unsplash.com/photo-1586618754080-135516049958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxzdW4lMjB0ZW1wbGUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgxMzY2NzQwfDA&ixlib=rb-4.1.0&q=85";
